//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { pageModule, categoryModule, pageIdModule, newUserActivity, getNotifyByPageType } from "@/api/index.js";
import { getCookie } from "@/utils/auth.js";
import Swiper from "swiper/swiper-bundle.min.js";
import { List, PullRefresh, Sticky, Overlay, Loading } from "vant";
import TabBar from "@/components/footer";
export default {
  data() {
    return {
      pageData: {},
      currentTabIndex: 0, //选中tab的index
      currentTabCid: "", //商品分类的cid
      pageSize: 10, //每页数据
      offset: 1, //当前页数
      categoryList: [], //分类商品
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      headerFixed: false,
      showFloating: false,
      catEmpty: false,
      showLoading: true,//页面加载loading
      index_popup_url: "",
      new_user_page_header_url: "",
      new_user_page_popup_url: "",
      new_user_gift_url: "",
      order_unlock_popup_url: "",
      index_url: "",
      bindStatus: false, //是否领取   默认未领取
      showNewComer: false, //显示首页弹层
      showPulicNotice: false, //打开未关注公众号弾图配置
      tipImgSrc: "", //提示未关注公众号图片
      redirectUrl: "", //跳转地址
      informText: ""
    };
  },

  components: {
    List: List,
    [PullRefresh.name]: PullRefresh,
    [Sticky.name]: Sticky,
    TabBar,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },

  computed: {},

  created() {
    if(this.$route.query.pageId){
      this.getPageModule();
      this.getNotify()
    }
  },

  mounted() {
    this.swiperobj();
    // handleScroll为页面滚动的监听回调
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    isFiexed(isFiexed) {
      console.log(isFiexed, "isFiexed");
      var box = document.querySelector(".goods-list");
      console.log(box, "box");
    },
    handleScroll() {
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 判断页面滚动的距离是否大于吸顶元素的位置

      this.headerFixed =
        scrollTop > this.offsetTop + this.offsetHeight * 2 + 15;
      if (scrollTop > 300) {
        this.showFloating = true;
      } else {
        this.showFloating = false;
      }
      // console.log(scrollTop,this.offsetTop,this.offsetHeight)
      // console.log(this.headerFixed ,'this.headerFixed ')
    },
    onLoad() {
      this.offset++;
      this.getCategoryModule();
    },
    onRefresh() {
      this.getCategoryModule();
    },
    getPageModule(type) {
      let pageId = this.$route.query.pageId
      pageIdModule(pageId).then((res) => {
        let pageData = res.data;
        let informText = ""
        pageData.modulePageInfoList.map((item) => {
          item.content = JSON.parse(item.content);
          if (item.moduleType == 5 && item.isShow == 1) {
            item.content.titles.map((item1) => {
              item1.active = false;
            });
            //默认选中第一个tab
            this.currentTabCid = item.content.titles[0].cid;
            item.content.titles[0].active = true;
            this.getCategoryModule();
          }else if(item.moduleType == 6){
            informText = item.content.text.replace(/\n/g,'')
          }
        });
        this.pageData = pageData;
        console.log(this.pageData, "this.pageData");
        this.$nextTick(() => {
          this.swiperobj();
        });
        //loading隐藏
        this.showLoading= false
        this.$nextTick(function () {
          // 这里fixedHeaderRoot是吸顶元素的ID
          let header = document.getElementById("tabBox");
          if (header != undefined) {
            // 这里要得到top的距离和元素自身的高度
            this.offsetTop = header.offsetTop;
            this.offsetHeight = header.offsetHeight;
            console.log(
              "offsetTop:" + this.offsetTop + "," + this.offsetHeight
            );
          } else {
            window.removeEventListener("scroll", this.handleScroll);
          }
       
          console.log(informText,'informText')
            this.informText= informText
            this.informScroll();
          
        });

        //请求新人活动
        this.getNewUserActivity();
      });
    },
    //点击搜索
    goSearch() {
      // window.location.href = process.env.PRODUCTURL + "/goodsSearch";
      this.$router.push('/goodsSearch')
    },
    //返回顶部
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    goProduct(item, index, item1, index1) {
      let ModuleTypes = [
        "banner",
        "图片模块",
        "主题组合模块",
        "专题模块",
        "信息流模块",
      ];
      console.log();
      let sortNum = index + 1;
      //如果有新人活动模块  sortNum  从第二个开始  不加1  为了和没有新人专享的神策埋点数据一致
      if (this.index_url != "" && index >= 2) {
        sortNum = index;
      } else {
        sortNum = index + 1;
      }
      //神策
      if (item.moduleType == 0) {
        sa.track("position_Click", {
          platform_type: "H5",
          page_name: "首页",
          belong_page: location.href,
          module_type: "banner",
          module_sort: sortNum + "",
          operat_type: "图片",
          element_name: "banner_" + (index1 + 1),
          urt: item1.picRedirectUrl + "",
          page_id: this.pageData.id,
          module_name: "",
        });
      } else if (
        item.moduleType == 1 &&
        item1.picRedirectUrl.indexOf("newcomersList") < 0
      ) {
        sa.track("position_Click", {
          platform_type: "H5",
          page_name: "首页",
          belong_page: location.href,
          module_type: "图片模块",
          module_sort: sortNum + "",
          operat_type: "图片",
          element_name: "picture_" + (index1 + 1),
          urt: item1.picRedirectUrl + "",
          page_id: this.pageData.id,
          module_name: item.moduleTitle,
        });
      } else if (item.moduleType == 2) {
        sa.track("position_Click", {
          platform_type: "H5",
          page_name: "首页",
          belong_page: location.href,
          module_type: "主题组合模块",
          module_sort: sortNum + "",
          operat_type: "图片",
          element_name: "theme_" + (index1 + 1),
          urt: item1.picRedirectUrl + "",
          page_id: this.pageData.id,
          module_name: item.moduleTitle,
        });
      } else if (item.moduleType == 4) {
        sa.track("position_Click", {
          platform_type: "H5",
          page_name: "首页",
          belong_page: location.href,
          module_type: "专题模块",
          module_sort: sortNum + "",
          operat_type: "商品",
          element_name: item1.title,
          urt: item1.pageUrl,
          page_id: this.pageData.id,
          module_name: item.moduleTitle,
        });
      } else if (item.moduleType == 5) {
        sa.track("position_Click", {
          platform_type: "H5",
          page_name: "首页",
          belong_page: location.href,
          module_type: "信息流模块",
          module_sort: sortNum + "",
          operat_type: "商品",
          element_name: item1.name,
          urt: item1.goodsCode,
          page_id: this.pageData.id,
          module_name: "",
        });
      }

      // if(type == 0){
      if (item.moduleType == 4) {
        window.location.href =
          item1.pageUrl + "?utm_source=" + this.pageData.suffix;
      } else if (item.moduleType == 5) {
        window.location.href =
          process.env.PRODUCTURL +
          "/detail/" +
          item1.goodsCode +
          "?utm_source=" +
          this.pageData.suffix;
      } else {
        console.log(item1, "item1");
        if (item1.redirectType == 1) {
          if (item1.picRedirectUrl.indexOf("?") == -1) {
            // 如何是新人专享入口
            if (item1.picRedirectUrl.indexOf("newcomersList") >= 0) {
              this.$router.push({
                path: "/newcomersList",
                query: {
                  new_user_page_popup_url: this.new_user_page_popup_url,
                  new_user_gift_url: this.new_user_gift_url,
                  order_unlock_popup_url: this.order_unlock_popup_url,
                  new_user_page_header_url: this.new_user_page_header_url,
                  bindStatus: this.bindStatus,
                },
              });
              sa.track("Newuserposition_click", {
                page_name: "首页",
                belong_page: location.href,
              });
            } else {
              window.location.href =
                item1.picRedirectUrl + "?utm_source=" + this.pageData.suffix;
            }
          } else {
            window.location.href =
              item1.picRedirectUrl + "&utm_source=" + this.pageData.suffix;
          }
        } else if (item1.redirectType == 3) {
          window.location.href =
            process.env.PRODUCTURL +
            "/detail/" +
            item1.goodsCode +
            "?utm_source=" +
            this.pageData.suffix;
        }
      }

      // }
      // console.log(item1, type);
    },
    //专题查看更多
    lookMore(item, index) {
      //神策
      sa.track("position_Click", {
        platform_type: "H5",
        page_name: "首页",
        belong_page: location.href,
        module_type: "专题模块",
        module_sort: index + 1 + "",
        operat_type: "按钮",
        element_name: "查看更多",
        urt:
          process.env.PAGEURL +
          "/page" +
          item.content.collectionPageUrl +
          ".html" +
          "?utm_source=" +
          this.pageData.suffix,
        page_id: this.pageData.id,
        module_name: item.moduleTitle,
      });
      //自定义跳转
      if (item.content.collectionPageCustom) {
        window.location.href = item.content.collectionPageCustom;
      } else {
        window.location.href =
          process.env.PAGEURL +
          "/page" +
          item.content.collectionPageUrl +
          ".html" +
          "?utm_source=" +
          this.pageData.suffix;
      }
    },
    //选择tab
    checkTab(item, index, item1, index1) {
      item.content.titles.map((item3) => {
        item3.active = false;
      });
      item1.active = true;
      this.currentTabCid = item1.cid;
      this.offset = 1;
      this.finished = false;
      this.getCategoryModule(1);
      this.$nextTick(() => {
        // document.documentElement.scrollTop = document.body.scrollTop = this.offsetTop
        let header = document.getElementById("tabBox");
        //  window.scrollTo(0,(this.offsetTop+this.offsetHeight*2+15))
      });
      //神策
      sa.track("position_Click", {
        platform_type: "H5",
        page_name: "首页",
        belong_page: location.href,
        module_type: "信息流模块",
        module_sort: index + 1 + "",
        operat_type: "tab",
        element_name: item1.title,
        urt: item1.cid,
        page_id: this.pageData.id,
        module_name: "",
      });
    },
    //分类商品
    getCategoryModule(type) {
      let params = {
        cid: this.currentTabCid,
        pageSize: this.pageSize,
        pageNo: this.offset,
      };
      categoryModule(params).then((res) => {
        let data = res.data;
        this.loading = false;
        if (type == 1) {
          this.categoryList = data.result;
          this.$nextTick(() => {
            window.scrollTo(0, this.offsetTop);
          });
        } else {
          this.categoryList = this.categoryList.concat(data.result);
        }
        if (this.offset >= data.totalPage) {
          this.finished = true;
          console.log(111111);
        }
      });
    },
    //swiper
    swiperobj() {
      var swiper = new Swiper(".swiper", {
        pagination: {
          el: ".swiper-pagination",
          // clickable: true,
        },
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        lazyLoading: true,
      });
      // return swiper;
    },

    // 获取新人专享活动
    getNewUserActivity: function () {
      let hdu = getCookie("hdu");
      let hdt = getCookie("hdt");
      let _this = this;
      newUserActivity(hdu).then((res) => {
        console.log("新人专享返回---------", res);
        if (res.code == 1 && res.data != null) {
          _this.index_url = res.data.index_url;

          _this.index_popup_url = res.data.index_popup_url;
          _this.new_user_page_header_url = res.data.new_user_page_header_url;
          _this.new_user_page_popup_url = res.data.new_user_page_popup_url;
          _this.new_user_gift_url = res.data.new_user_gift_url;
          _this.order_unlock_popup_url = res.data.order_unlock_popup_url;
          _this.bindStatus = res.data.bindStatus;
          //是否领取
          if (!res.data.bindStatus) {
            _this.showNewComer = true;
            sa.track("notice_show", {
              notice_type: "首页红包",
              page_name: "首页",
              belong_page: location.href,
            });
          }
          if (_this.index_url != "" && _this.index_url != null) {
            //如果有地址，添加到列表中
            let newPageData = _this.pageData;
            let obj = {
              content: {
                pictures: [
                  {
                    picUrl: _this.index_url,
                    picDesc: "",
                    picRedirectUrl: "../newcomersList/index",
                    redirectType: 1,
                  },
                ],
                picNum: 1,
              },
              createByName: "admin",
              createTime: null,
              id: null,
              isShow: 1,
              moduleDesc: "",
              modulePageId: 20,
              moduleTitle: "",
              moduleType: 1,
              priority: 2,
              updateByName: "admin",
            };
            //有无通知模块
            let hasInformModule = false
            newPageData.modulePageInfoList.map(item=> {
              if(item.moduleType==6){
                hasInformModule = true
              }
            })
            if(hasInformModule){
              newPageData.modulePageInfoList.splice(2, 0, obj);
            }else{
              newPageData.modulePageInfoList.splice(1, 0, obj);
            }

            _this.pageData = newPageData;

            console.log("pageData-----------", _this.pageData);
            sa.track("Newuserposition_show", {
              page_name: "首页",
              belong_page: location.href,
            });
          }
        }
      });
    },

    // 进入新人专享列表
    gotoNewComerFun: function () {
      sa.track("notice_click", {
        notice_type: "首页红包",
        page_name: "首页",
        belong_page: location.href,
        click_type: 1,
      });
      this.showNewComer = false; //关闭弹层
      this.$router.push({
        path: "/newcomersList",
        query: {
          new_user_page_popup_url: this.new_user_page_popup_url,
          new_user_gift_url: this.new_user_gift_url,
          order_unlock_popup_url: this.order_unlock_popup_url,
          new_user_page_header_url: this.new_user_page_header_url,
          bindStatus: this.bindStatus,
        },
      });
    },
    // 关闭新人大礼包界面
    closePopupFun: function () {
      this.showNewComer = false;
      //首页红包点击埋点
      sa.track("notice_click", {
        notice_type: "首页红包",
        page_name: "首页",
        belong_page: location.href,
        click_type: 0,
      });
    },
    getNotify() {
      let hdu = getCookie("hdu");
      if(hdu !="" && hdu !=null && hdu != undefined){
        let cache = localStorage.getItem("OFFICIAL-ACCOUNT-TIP");
        if(this.isToday(cache)) return;
        getNotifyByPageType(hdu).then(res=>{
          console.log(res,'res')
          if(res.result != null){
            this.showPulicNotice = true
            this.tipImgSrc = res.result.picUrl
            this.redirectUrl = res.result.redirectUrl //跳转地址
          }
        })
      }
    },
    gotoPulicNoticeFun(){
      this.picturenoticeClick(1)
      window.location.href= this.redirectUrl
    },
    //关闭公众号提示
    closePulicNoticeFun(){
      //记录本地缓存
			localStorage.setItem("OFFICIAL-ACCOUNT-TIP", +new Date())
			//神策
      this.picturenoticeClick(0)
      this.showPulicNotice = false
    },
    isToday(date) {
      if(date){
        return date.toString().slice(0, 6) === Date.parse(new Date()).toString().slice(0, 6);
      }else{
        return false;
      }
      
    },
    //神策 关注公众号点击埋点
    picturenoticeClick(clickType){
      var params = {
        referrer:'',// 前向地址
        belong_page: window.location.href,//当前页面url
        page_name: "商城首页",
        click_type: clickType,
      };
      sa.track("PicturenoticeClick",params);
    },
    //查看通知
    goInformDetail(index) {
      //神策
      sa.track("position_Click", {
        platform_type: "H5",
        page_name: "首页",
        belong_page: location.href,
        module_type: "通知模块",
        module_sort: index + 1 + "",
        operat_type: "",
        element_name: '通知条',
        urt: location.href+ '/inform',
        page_id: this.pageData.id,
        module_name: "",
      });
      this.$router.push('/inform')
    },
    //通知滚动
    informScroll() {
      var speed = 40;
      var tab = document.getElementById("demos");
      var tab1 = document.getElementById("demo1");
      var tab2 = document.getElementById("demo2");
      tab2.innerHTML = tab1.innerHTML;
      console.log(11111);
      var MyMar = setInterval(() => {
        if (tab2.offsetWidth - tab.scrollLeft <= 0)
          tab.scrollLeft -= tab1.offsetWidth;
        else {
          tab.scrollLeft++;
        }
      }, speed);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(MyMar);
        MyMar = "";
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/view/index/Preview.vue